import React, { useEffect, useRef, useState} from "react";
import { useAppState } from "@/contexts/AppStateContext";
import { Button } from "@/components/Button/Button";
import { useStyle } from "@/contexts/StyleContext";
import { isValidUrl } from "@/utils/urlUtils";

interface TemplateProps {
  customContent?: React.ReactNode;
  buttonText?: string;
  buttonUrl?: string;
  backgroundColor?: string;
  primaryColor?: string;
  textColor?: string;
  serialCode?: string;
  buttonTextColor?: string;
}

export const Template = ({ serialCode, customContent, buttonText, buttonUrl, backgroundColor, primaryColor, textColor, buttonTextColor }: TemplateProps) => {
  const { appState } = useAppState();
  const [showTemplate, setShowTemplate] = useState(false);
  const { setBrandingColors } = useStyle();
  const templateRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (appState === "showtemplate") {
      setShowTemplate(true);
      if (templateRef.current) {
        templateRef.current.scrollIntoView({ behavior: "smooth" });
      }
      setBrandingColors(
        backgroundColor || '#000000',
        textColor || '#ffffff',
        primaryColor || '#00ffc2',
        buttonTextColor || '#FFFFFF'  
      );
    }
  }, [appState, backgroundColor, textColor, primaryColor, buttonTextColor, setBrandingColors]);

  return (
    <div
      ref={templateRef}
      className={`template ${showTemplate ? "visible" : "hidden"} flex flex-col items-center w-full min-h-0 flex-1 gap-28`}
    >
      <div className="flex flex-col text-color  w-full">
        {customContent}
      </div>
      <div className="flex flex-col items-center text-color justify-center w-full">
        {buttonText && buttonUrl && (
          <div className="flex justify-center w-full">
            <Button
              href={isValidUrl(buttonUrl) ? buttonUrl : `https://${buttonUrl}`}
              text={buttonText}
              className="text-xl mx-auto block"
              style={{ color: buttonTextColor }}
            >
            </Button>
          </div>
        )}
        <h1 className="text-xl text-color mt-14 w-full text-center">{serialCode}</h1>
      </div>
    </div>
  );
};